// extracted by mini-css-extract-plugin
module.exports = {"case_main_title":"CaseMainTitle_case_main_title__3hFtS"};